<template>
    <div>
        <swb-query-sort-area :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="table-layout">
            <el-table ref="tableList" :data="bizUnionTypeList" border style="width: 100%" highlight-current-row @current-change="handleSelectionChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : hashCheckedRow(rows.row)}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="code" label="CODE" width="100" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="类型名称" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="供应商参与" width="80" align="center">
                    <template slot-scope="rows">
                        <span class="font-green" v-if="rows.row.vendorAllowed">是</span>
                    </template>
                </el-table-column>
                <el-table-column label="服务商参与" width="80" align="center">
                    <template slot-scope="rows">
                        <span class="font-green" v-if="rows.row.servicerAllowed">是</span>
                    </template>
                </el-table-column>
                <el-table-column label="零售商参与" width="80" align="center">
                    <template slot-scope="rows">
                        <span class="font-green" v-if="rows.row.retailerAllowed">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="desc" label="描述" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import bizUnionApi from '../../api/bizUnion'

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "类型名称",
                "code": "name",
                "valueType": "String",
                "basic": true
            }
        ]
    };

    export default {
        name: 'swb-biz-union-type-select',
        props: ['bizUnionTypeCodeList'],
        avlActions: '',
        avlScopes: 'operate',
        desc: '商业联盟类型-选择',
        data: function () {
            return {
                bizUnionTypeList: [],
                selectBizUnionType: {},
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            //----------------------搜索排序----------------------------
            //查询排序配置信息
            let queryConfig = searchConfigData || {};
            //
            this.queryConfig = queryConfig;
            //
            this.getBizUnionTypeList();
        },
        methods: {
            queryHandler(queryModel){
                this.queryModel = queryModel;
                //
                this.getBizUnionTypeList();
            },
            getBizUnionTypeList: function () {
                let self = this;
                //
                let postData = {};
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                bizUnionApi.getBizUnionTypeList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.bizUnionTypeList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleSelectionChange: function (selRows) {
                //
                this.selectBizUnionType = selRows;
            },
            hashCheckedRow(row){
                //
                return this.selectBizUnionType.code == row.code;
            },
            getDlgResult: function () {
                let result = {};
                let selectBizUnionType = this.selectBizUnionType;
                if(!Utils.isNoB(selectBizUnionType.code)) {
                    result.type = 'info';
                    result.data = selectBizUnionType;
                } else {
                    result.type = 'warn';
                    result.message = '请至少选择一个类型'
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizUnion/BizUnionTypeForSelect.vue